import { render } from "./EditBanner.vue?vue&type=template&id=79c92352&scoped=true"
import script from "./EditBanner.vue?vue&type=script&lang=js"
export * from "./EditBanner.vue?vue&type=script&lang=js"

import "./EditBanner.vue?vue&type=style&index=0&id=79c92352&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c92352"]])

export default __exports__